import { useCodebaseStore } from "@/store/zustand/codebaseStore";
import { getLookupKeyForComponent } from "@/utils/extractElementsUtils";
import { JsxElement, JsxElementType } from "@/utils/jsxElementTypes";
import { ReactFramework } from "@/utils/templateProjects";
import { useActiveProject } from "@/utils/utils";
import { useMemo } from "react";

export const useAssetComponents = () => {
  const project = useActiveProject();

  const treeElementLookup = useCodebaseStore(
    (state) => state.treeElementLookup
  );

  return useMemo(() => {
    const componentKeyToComponent: { [key: string]: JsxElement } = {};
    const componentImportToStory: { [key: string]: JsxElement[] } = {};

    Object.keys(treeElementLookup)?.forEach((codebaseId: string) => {
      const element: JsxElement = treeElementLookup[codebaseId];

      if (!element) {
        return;
      }

      const filenameWithoutExtension = element.filename.replace(
        /\.[^/.]+$/,
        ""
      );

      if (
        filenameWithoutExtension.includes("tempobook/dynamic") ||
        filenameWithoutExtension.includes("tempobook/storyboards")
      ) {
        return;
      }

      if (
        project?.framework === ReactFramework.NEXT_JS &&
        filenameWithoutExtension.endsWith("pages/_app")
      ) {
        return;
      }

      if (filenameWithoutExtension.endsWith("_layout")) {
        return;
      }

      if (element.type === JsxElementType.StorybookComponent) {
        const key = getLookupKeyForComponent(element);
        // @ts-expect-error TS2538
        if (!componentImportToStory[key]) {
          // @ts-expect-error TS2538
          componentImportToStory[key] = [];
        }

        // @ts-expect-error TS2538
        componentImportToStory[key].push(element);
        return;
      }

      if (
        element.type === JsxElementType.Component ||
        element.type === JsxElementType.LibraryComponent
      ) {
        const key = getLookupKeyForComponent(element);
        // @ts-expect-error TS2538
        componentKeyToComponent[key] = element;
        return;
      }
    });

    return {
      componentKeyToStories: componentImportToStory,
      componentKeyToComponent,
    };
  }, [treeElementLookup]);
};
